import { render, staticRenderFns } from "./delivery-otherOwner.vue?vue&type=template&id=84d341b2&scoped=true&"
import script from "./delivery-otherOwner.vue?vue&type=script&lang=js&"
export * from "./delivery-otherOwner.vue?vue&type=script&lang=js&"
import style0 from "./delivery-otherOwner.vue?vue&type=style&index=0&id=84d341b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d341b2",
  null
  
)

export default component.exports